<template>
  <v-app>
    <background />

    <v-main>
      <router-view></router-view>
    </v-main>
    <dialogLocations />
    <dialogPrizes />
    <dialogContact />
    <snackbar />
    <reward />
  </v-app>
</template>

<script>
import Snackbar from "./components/Snackbar";
import Reward from "./components/Reward";

import DialogLocations from "./components/DialogLocations";
import DialogPrizes from "./components/DialogPrizes";
import DialogContact from "./components/DialogContact";
import Background from "./components/Background.vue";

export default {
  name: "App",
  components: {
    Snackbar,
    Reward,
    DialogPrizes,
    DialogContact,
    Background,
    DialogLocations,
  },
};
</script>
<style>
@font-face {
  font-family: josefinSans;
  src: url("./assets/static/JosefinSans-Regular.ttf");
}
* {
  font-family: josefinSans;
}
.v-label {
  color: white !important;
}
::-webkit-scrollbar {
  width: 0px; /* For Chrome, Safari, and Opera */
}
.v-card,
.v-dialog {
  border-radius: 20px !important;
}
</style>
